<template>
    <li class="relative">
        <Component
            :is="pin.type === 'item' ? Link : 'a'"
            :href="pin.type === 'item' ? route('web.catalog.products.show', pin.slug) : pin.route"
            :target="pin.type === 'item' ? undefined : '_blank'"
            class="flex gap-3 group items-center leading-none max-w-full w-full"
        >
            <!-- Image or Video Icon -->
            <span
                v-if="pin.asset_is_video_resource === 'true'"
                aria-hidden="true"
                class="bg-blue-650/10 flex items-center justify-center rounded-md shrink-0 size-[60px]"
            >
                <BaseSvg name="PlayCircle" class="fill-v2-gray-70 size-[30.32px] dark:fill-v2-gray-90"/>
            </span>
            <span
                v-else-if="pin.thumbnail"
                aria-hidden="true"
                class="bg-v2-gray-130 dark:bg-v2-gray-40 flex items-center justify-center rounded-md shrink-0 size-[60px]"
            >
                <img :srcset="useAssetTransforms().assetUrl(pin.thumbnail)" height="32" width="32" alt=""/>
            </span>
            <span
                v-else
                aria-hidden="true"
                class="flex items-center justify-center rounded-md shrink-0 size-[60px] bg-v2-gray-130 dark:bg-v2-gray-40"
            >
                <BaseSvg
                    :name="pin.type === 'resource' ? 'icon-document' : 'icon-products-cube'"
                    class="fill-gray-400"
                />
            </span>



            <!-- Text Content -->
            <span class="flex flex-col overflow-hidden mr-16">
        <span class="flex items-center">
          <span class="decoration-gray-350 font-medium leading-none mr-1 text-v2-gray-20 text-sm underline-offset-2 group-hover:underline dark:text-v2-gray-130">
            {{ pin.name }}
                    </span>
                    <span
                        v-if="pin.vendor"
                        class="bg-v2-gray-130 inline-block leading-none pb-[3px] px-1.5 pt-0.5 rounded-md text-[12px] text-v2-gray-20 dark:bg-v2-gray-60 dark:text-v2-gray-90"
                    >
                        <span class="sr-only">from</span>
                        {{ pin.vendor }}
                    </span>
                </span>
                <span v-if="pin.description" aria-hidden="true" class="mt-1 text-v2-gray-80 text-xs truncate">
                    {{ pin.description }}
                </span>
            </span>
        </Component>
<!--        More Menu-->
        <span v-click-outside="closeMenu">
            <PinItemDropdownMenu :pin="pin" :toggle-more="toggleMore" :is-more-open="isMoreOpen"/>
        </span>
    </li>
</template>

<script setup>
import {ref} from 'vue';
import {BaseSvg, PinItemDropdownMenu} from '@/Components';
import {useAssetTransforms} from "@/Composables";
import {Link} from "@inertiajs/vue3";

const props = defineProps({
    pin: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['move-to', 'add-to', 'remove-pin', 'copy-link']);

const isMoreOpen = ref(false);
const isMoveOpen = ref(false);
const isAddOpen = ref(false);

function toggleMore() {
    isMoreOpen.value = !isMoreOpen.value;
    if (!isMoreOpen.value) {
        isMoveOpen.value = false;
        isAddOpen.value = false;
    }
}

const closeMenu = () => {
    isMoreOpen.value = false;
}
</script>
